import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_ENABLE_PETITION_STRENGTH_TIPS = createFcmDetails('enable_petition_strength_tips', {
	owner: 'Starfish',
	context: 'Petition Show Page',
	description: 'Used to enable the Carousel showing tips to enhance the strength of the petition',
	import: false,
});
